var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666016,
    width: 45.334,
    height: 45.3333,
    rx: 5.83333,
    fill: "url(#paint0_linear_3820_34556)",
    fillOpacity: 0.07
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.08268,
    y: 0.416667,
    width: 44.5007,
    height: 44.5,
    rx: 5.41667,
    stroke: "url(#paint1_linear_3820_34556)",
    strokeOpacity: 0.5,
    strokeWidth: 0.833333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4154 27.0046C19.2035 25.7019 12.8841 27.1448 12.2994 30.2311C11.7146 33.3174 17.0902 36.8746 24.2919 38.1873C31.5038 39.4899 37.8231 38.047 38.4079 34.9607C38.9926 31.8745 33.6171 28.3172 26.4154 27.0146V27.0046Z",
    fill: "url(#paint2_linear_3820_34556)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5349 27.0244C17.1611 25.7518 21.6544 25.3911 26.5479 26.2729C31.4413 27.1547 35.514 29.0686 37.4939 31.1728L39.2892 31.4935L38.725 34.4695V34.5296L38.7045 34.5597C38.0376 37.656 31.6465 39.0989 24.3627 37.7763C17.079 36.4636 11.6522 32.8863 12.1548 29.76L12.7396 26.6837L14.5349 27.0044V27.0244Z",
    fill: "url(#paint3_linear_3820_34556)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0907 23.4081C19.7557 22.0854 13.3337 23.5484 12.7387 26.6947C12.1437 29.8311 17.6014 33.4585 24.9364 34.7812C32.2714 36.1039 38.6933 34.6409 39.2883 31.4945C39.8834 28.3581 34.4257 24.7308 27.0907 23.4081Z",
    fill: "url(#paint4_linear_3820_34556)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8205 26.5634C14.3383 29.1286 18.9856 32.1247 25.2229 33.247C31.4499 34.3692 36.8973 33.2069 37.3897 30.6417C37.8719 28.0765 33.2247 25.0804 26.9874 23.9581C20.7603 22.8358 15.3129 23.9982 14.8205 26.5634Z",
    fill: "url(#paint5_linear_3820_34556)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.734 27.1044C15.2826 29.4692 19.54 32.2248 25.2233 33.2469C30.9169 34.279 35.8924 33.1968 36.3438 30.832C36.7952 28.4672 32.5378 25.7116 26.8545 24.6895C21.1609 23.6574 16.1854 24.7396 15.734 27.1044Z",
    fill: "url(#paint6_radial_3820_34556)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2553 33.1074C19.5617 32.0753 15.3249 29.2696 15.7865 26.8347C16.2482 24.3997 21.2339 23.2574 26.9275 24.2895C32.6211 25.3216 36.858 28.1273 36.3963 30.5623C35.9347 32.9972 30.9489 34.1395 25.2553 33.1074ZM27.1532 23.1071C19.9413 21.8045 13.6219 23.2474 13.0372 26.3337C12.4524 29.4199 17.828 32.9772 25.0297 34.2798C32.2415 35.5825 38.5609 34.1395 39.1457 31.0532C39.7304 27.967 34.3549 24.4097 27.1532 23.1071Z",
    fill: "url(#paint7_linear_3820_34556)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6231 25.9823L25.6637 25.6316L25.5303 26.323C24.9455 26.2228 24.3916 26.1526 23.8479 26.1226C23.3041 26.0925 22.822 26.1025 22.3911 26.1526C21.9705 26.2027 21.6217 26.303 21.3447 26.4332C21.0677 26.5735 20.9139 26.7539 20.8728 26.9944C20.8113 27.315 20.9139 27.6056 21.1806 27.8561C21.4473 28.1066 21.7961 28.3371 22.2167 28.5375C22.6373 28.7379 23.1092 28.9183 23.6324 29.0786C24.1454 29.2389 24.6275 29.3792 25.0584 29.5195C25.4995 29.6498 25.8586 29.78 26.1458 29.9003C26.4331 30.0205 26.5664 30.1408 26.5459 30.261C26.5357 30.3311 26.4331 30.3812 26.2381 30.4113C26.0432 30.4414 25.7662 30.4213 25.3867 30.3512C24.8327 30.251 24.3505 30.0907 23.9299 29.8602C23.5093 29.6297 23.2631 29.3792 23.1605 29.0886L20.6471 28.6377L20.3086 30.4213L22.822 30.8722L22.8733 30.5817C23.4478 30.8322 24.0223 31.0426 24.5762 31.2029L24.4326 31.9444L26.392 32.2951L26.5254 31.6138C27.1101 31.7039 27.6641 31.7741 28.2078 31.8041C28.7515 31.8442 29.2337 31.8342 29.6543 31.7941C30.0852 31.744 30.4237 31.6538 30.7007 31.5236C30.9674 31.3833 31.1213 31.2029 31.1726 30.9524C31.2342 30.6217 31.1316 30.3311 30.8648 30.0706C30.5981 29.8101 30.2391 29.5796 29.8082 29.3792C29.3773 29.1788 28.8952 28.9884 28.372 28.8281C27.8385 28.6678 27.3564 28.5175 26.9152 28.3772C26.4741 28.2369 26.0945 28.1166 25.797 27.9964C25.4995 27.8762 25.3559 27.7559 25.3764 27.6357C25.3969 27.5355 25.5098 27.4854 25.7252 27.4753C25.9406 27.4653 26.2074 27.4753 26.5254 27.5355C26.7819 27.5856 27.0281 27.6457 27.264 27.7359C27.5102 27.816 27.7257 27.9162 27.9103 28.0164C28.095 28.1166 28.2591 28.2369 28.3822 28.3571C28.5053 28.4774 28.5874 28.5976 28.5977 28.7179L31.1418 29.1788L31.4701 27.4353L28.9259 26.9743L28.8746 27.2749C28.7105 27.2048 28.5156 27.1146 28.2694 27.0244C28.0232 26.9342 27.7462 26.834 27.4384 26.7439L27.5923 25.9422L27.6231 25.9823Z",
    fill: "url(#paint8_linear_3820_34556)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6768 25.702L25.7174 25.3513L25.584 26.0427C24.9993 25.9425 24.4453 25.8724 23.9016 25.8423C23.3579 25.8123 22.8757 25.8223 22.4448 25.8724C22.0242 25.9225 21.6652 26.0227 21.3984 26.1529C21.1215 26.2932 20.9676 26.4736 20.9265 26.7141C20.865 27.0347 20.9676 27.3253 21.2343 27.5758C21.501 27.8263 21.8498 28.0568 22.2704 28.2572C22.691 28.4576 23.1629 28.638 23.6861 28.7983C24.2093 28.9586 24.6812 29.0989 25.1121 29.2392C25.5532 29.3695 25.9123 29.4997 26.1995 29.62C26.4868 29.7402 26.6201 29.8605 26.5996 29.9807C26.5894 30.0509 26.4868 30.101 26.2919 30.131C26.0969 30.1611 25.82 30.1411 25.4404 30.0709C24.8864 29.9707 24.4043 29.8104 23.9836 29.5799C23.563 29.3494 23.3168 29.0989 23.2142 28.8083L20.7008 28.3574L20.3623 30.1411L22.8757 30.592L22.927 30.3014C23.5015 30.5519 24.076 30.7623 24.6299 30.9226L24.4863 31.6641L26.4457 32.0149L26.5791 31.3335C27.1639 31.4237 27.7178 31.4938 28.2615 31.5239C28.8053 31.5639 29.2874 31.5539 29.708 31.5138C30.1389 31.4637 30.4774 31.3736 30.7544 31.2433C31.0211 31.103 31.175 30.9226 31.2263 30.6721C31.2879 30.3415 31.1853 30.0509 30.9186 29.7903C30.6518 29.5298 30.2928 29.2993 29.8619 29.0989C29.431 28.8985 28.9489 28.7081 28.4257 28.5478C27.8922 28.3875 27.4101 28.2372 26.9689 28.0969C26.5278 27.9566 26.1482 27.8364 25.8507 27.7161C25.5532 27.5959 25.4096 27.4756 25.4301 27.3554C25.4506 27.2552 25.5635 27.2051 25.7789 27.185C25.9944 27.175 26.2611 27.185 26.5791 27.2452C26.8356 27.2953 27.0818 27.3554 27.3177 27.4456C27.5639 27.5257 27.7794 27.6259 27.964 27.7261C28.1487 27.8263 28.3128 27.9466 28.4359 28.0668C28.559 28.1871 28.6411 28.3073 28.6514 28.4276L31.1955 28.8885L31.5238 27.145L28.9797 26.684L28.9181 26.9846C28.754 26.9145 28.559 26.8243 28.3128 26.7341C28.0666 26.6439 27.7896 26.5437 27.4819 26.4536L27.6358 25.6519L27.6768 25.702Z",
    fill: "url(#paint9_linear_3820_34556)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0964 11.2707C13.8098 12.5669 11.8122 14.4062 10.4679 16.6158C7.10085 22.1584 9.08589 27.9973 14.9154 29.6514C18.4081 30.6389 22.4912 29.8983 25.9337 27.9602C28.2202 26.6641 30.2178 24.8248 31.5621 22.6152C34.9292 17.0726 32.9441 11.2337 27.1146 9.59192C23.622 8.60438 19.5388 9.33269 16.0964 11.2831V11.2707Z",
    fill: "url(#paint10_linear_3820_34556)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M32.215 12.9239L31.1345 11.0846L30.8833 11.2204C29.8908 10.2699 28.5967 9.5169 27.0263 9.07251C23.4708 8.06027 19.3122 8.81328 15.8195 10.8007C13.4953 12.1215 11.46 13.9855 10.0905 16.2445C8.50752 18.8615 8.08036 21.5279 8.68341 23.8239L8.43214 23.9721L9.47492 25.7373C10.5051 27.4779 12.2515 28.8357 14.6134 29.5147C18.1689 30.5269 22.3275 29.7739 25.8201 27.7865C28.1444 26.4656 30.1797 24.6016 31.5491 22.3426C33.5844 18.985 33.6975 15.5286 32.2024 12.9239H32.215Z",
    fill: "url(#paint11_linear_3820_34556)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7891 9.03704C12.4649 10.3579 10.4296 12.2219 9.06014 14.4809C5.63028 20.1222 7.65302 26.0598 13.583 27.7386C17.1385 28.7509 21.2971 27.9979 24.7897 26.0104C27.114 24.6896 29.1493 22.8256 30.5187 20.5666C33.9486 14.9253 31.9259 8.98766 25.9959 7.30884C22.4404 6.2966 18.2818 7.04961 14.7891 9.03704Z",
    fill: "url(#paint12_linear_3820_34556)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4785 10.2094C13.6317 11.2587 12.0235 12.7276 10.943 14.5176C8.22931 18.9862 9.82489 23.6894 14.5237 25.0226C17.3379 25.8249 20.6296 25.2324 23.4061 23.6523C25.253 22.6031 26.8611 21.1341 27.9416 19.3442C30.6553 14.8755 29.0597 10.1724 24.361 8.83918C21.5467 8.0368 18.2551 8.62933 15.4785 10.2094Z",
    fill: "url(#paint13_linear_3820_34556)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8804 10.9003C14.0587 11.9372 12.4757 13.3938 11.4078 15.1467C8.73172 19.5536 10.3147 24.1951 14.9381 25.5036C17.7147 26.2936 20.9687 25.7011 23.695 24.158C25.5167 23.1211 27.0997 21.6645 28.1676 19.9116C30.8436 15.5047 29.2606 10.8632 24.6372 9.55473C21.8607 8.76469 18.6067 9.35722 15.8804 10.9003Z",
    fill: "url(#paint14_radial_3820_34556)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M15.8804 10.9003C14.0587 11.9372 12.4757 13.3938 11.4078 15.1467C8.73172 19.5536 10.3147 24.1951 14.9381 25.5036C17.7147 26.2936 20.9687 25.7011 23.695 24.158C25.5167 23.1211 27.0997 21.6645 28.1676 19.9116C30.8436 15.5047 29.2606 10.8632 24.6372 9.55473C21.8607 8.76469 18.6067 9.35722 15.8804 10.9003Z",
    fill: "url(#paint15_radial_3820_34556)"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5078 23.8496C20.7815 25.405 17.5275 25.9851 14.751 25.1951C10.115 23.8743 8.54456 19.2451 11.2206 14.8382C12.2885 13.073 13.8841 11.6164 15.6932 10.5918C18.4195 9.03641 21.6735 8.45623 24.4501 9.24626C29.0735 10.5548 30.6565 15.1962 27.9804 19.6031C26.9125 21.3684 25.3169 22.825 23.5078 23.8496ZM14.663 8.81421C12.3639 10.1227 10.3412 11.962 8.98429 14.1963C5.59212 19.776 7.58973 25.6518 13.4569 27.3183C16.9747 28.3182 21.0956 27.5775 24.5506 25.6148C26.8497 24.3063 28.8724 22.467 30.2293 20.2327C33.6215 14.6531 31.6239 8.77718 25.7567 7.1107C22.2389 6.11081 18.118 6.85147 14.663 8.81421Z",
    fill: "url(#paint16_linear_3820_34556)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0467 14.1833L24.426 13.7266L24.0993 14.2697C24.0114 14.1463 23.8858 14.0228 23.735 13.8747C23.5842 13.7266 23.3958 13.5908 23.1822 13.4426L24.0616 11.9983L23.8858 11.7144L23.5591 11.8255L23.534 11.8626L22.4535 11.554L21.6871 12.8131C21.2097 12.6773 20.7323 12.6156 20.2172 12.6156C19.7147 12.6156 19.2247 12.6773 18.7598 12.8131C18.4206 12.9118 18.1065 13.0476 17.805 13.2081C17.6919 13.2698 17.5788 13.3439 17.4783 13.4179C17.0889 13.6895 16.7622 14.0352 16.4984 14.4672C16.1466 15.0474 15.9833 15.5535 16.0084 15.9856C16.0461 16.4176 16.1717 16.7879 16.3979 17.1089C16.624 17.4298 16.9255 17.7138 17.2899 17.9483C17.6542 18.1828 17.9809 18.405 18.295 18.6025C18.6091 18.8001 18.8478 18.9976 19.0111 19.1827C19.187 19.3679 19.2121 19.5777 19.0739 19.7876C19.0237 19.874 18.9483 19.9357 18.8478 19.9975C18.7849 20.0345 18.7221 20.0592 18.6342 20.0839C18.4206 20.1579 18.1568 20.1456 17.8552 20.0592C17.4029 19.9357 17.0763 19.6888 16.8753 19.3185C16.6743 18.9482 16.6617 18.5161 16.825 18.01L16.6491 17.7261L16.3979 17.8989L14.7772 17.4422L13.2193 20.0098L12.6414 20.3925L12.8047 20.6764L14.8525 21.2566L15.1666 20.7381C15.4933 21.1455 15.8576 21.4664 16.2597 21.701L15.6817 22.6515L15.2671 22.7626L15.443 23.0465L17.0386 23.5032L17.7799 22.2811C18.2573 22.3922 18.7473 22.454 19.2498 22.4787C19.7398 22.491 20.2172 22.4416 20.682 22.3182C21.0213 22.2318 21.3479 22.096 21.6494 21.9232C21.7499 21.8614 21.8505 21.7997 21.951 21.738C22.3404 21.4664 22.6671 21.1208 22.9309 20.6764C23.2953 20.0839 23.4586 19.5654 23.4335 19.1334C23.4083 18.7013 23.2701 18.3186 23.0314 17.9853C22.7927 17.6644 22.4912 17.3805 22.1269 17.1336C21.7625 16.8867 21.4233 16.6645 21.1092 16.467C20.7951 16.2695 20.5564 16.072 20.368 15.8868C20.1795 15.7016 20.1544 15.5041 20.28 15.2943C20.3428 15.1955 20.4182 15.1091 20.5187 15.0597C20.5941 15.0227 20.6695 14.9857 20.77 14.9733C20.9961 14.9239 21.2348 14.9363 21.4861 15.0104C21.6871 15.0721 21.8756 15.1585 22.0389 15.2943C22.2022 15.4301 22.3279 15.5782 22.4158 15.7387C22.5038 15.9115 22.554 16.0967 22.5666 16.3065C22.5666 16.3682 22.5666 16.4423 22.5666 16.504L22.2902 16.6398L22.4535 16.9237L24.5265 17.5163L26.4487 14.3561L26.2728 14.0722L25.9964 14.2327L26.0467 14.1833Z",
    fill: "url(#paint17_linear_3820_34556)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6653 12.9007C17.5523 12.9624 17.4392 13.0365 17.3387 13.1105C16.9492 13.3821 16.6226 13.7278 16.3587 14.1598C16.0069 14.74 15.8436 15.2461 15.8687 15.6782C15.9064 16.1102 16.0321 16.4805 16.2582 16.8015C16.4844 17.1224 16.7859 17.4064 17.1502 17.6409C17.5146 17.8754 17.8412 18.0976 18.1553 18.2951C18.4694 18.4927 18.7081 18.6902 18.8714 18.8753C19.0473 19.0605 19.0725 19.2703 18.9343 19.4802C18.884 19.5666 18.8086 19.6283 18.7081 19.6901C18.6453 19.7271 18.5825 19.7518 18.4945 19.7765C18.2809 19.8505 18.0171 19.8382 17.7156 19.7518C17.2633 19.6283 16.9366 19.3814 16.7356 19.0111C16.5346 18.6408 16.522 18.2087 16.6854 17.7026L14.6375 17.1224L12.665 20.3566L14.7129 20.9368L15.027 20.4184C15.3536 20.8257 15.718 21.1467 16.12 21.3812L15.3034 22.7268L16.899 23.1835L17.6402 21.9614C18.1176 22.0725 18.6076 22.1342 19.1101 22.1589C19.6001 22.1713 20.0775 22.1219 20.5424 21.9984C20.8816 21.912 21.2083 21.7762 21.5098 21.6034C21.6103 21.5417 21.7108 21.48 21.8113 21.4183C22.2008 21.1467 22.5274 20.801 22.7913 20.3566C23.1556 19.7641 23.3189 19.2457 23.2938 18.8136C23.2687 18.3816 23.1305 17.9989 22.8918 17.6656C22.6531 17.3446 22.3516 17.0607 21.9872 16.8138C21.6229 16.5669 21.2836 16.3447 20.9696 16.1472C20.6555 15.9497 20.4168 15.7522 20.2283 15.5671C20.0399 15.3819 20.0147 15.1844 20.1404 14.9745C20.2032 14.8758 20.2786 14.7894 20.3791 14.74C20.4544 14.703 20.5298 14.6659 20.6303 14.6536C20.8565 14.6042 21.0952 14.6289 21.3465 14.6906C21.5475 14.7523 21.7359 14.8387 21.8993 14.9745C22.0626 15.1103 22.1882 15.2584 22.2762 15.4189C22.3641 15.5917 22.4144 15.7769 22.4269 15.9868C22.4395 16.1966 22.4018 16.4065 22.3139 16.6163L24.3869 17.2088L26.3091 14.0487L24.2361 13.4562L23.9094 13.9993C23.8215 13.8759 23.6959 13.7524 23.5451 13.6043C23.3943 13.4562 23.2059 13.3204 22.9923 13.1723L23.8717 11.728L22.2762 11.2712L21.5098 12.5304C21.0324 12.3946 20.555 12.3329 20.0399 12.3329C19.5373 12.3329 19.0473 12.3946 18.5825 12.5304C18.2433 12.6291 17.9292 12.7649 17.6276 12.9254L17.6653 12.9007Z",
    fill: "url(#paint18_linear_3820_34556)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M18.7081 19.6892C18.7081 19.6892 18.5825 19.7509 18.4945 19.7756C18.281 19.8497 18.0171 19.8373 17.7156 19.7509C17.3889 19.6522 17.1251 19.504 16.9241 19.2818C15.919 18.9732 14.9642 18.5288 14.0973 18.0227L12.6776 20.3558L14.7255 20.936L15.0396 20.4175C15.3662 20.8249 15.7306 21.1458 16.1326 21.3804L15.316 22.7259L16.9115 23.1826L17.6528 21.9605C18.1302 22.0716 18.6202 22.1334 19.1227 22.158C19.6127 22.1704 20.0901 22.121 20.555 21.9976C20.8942 21.9112 21.2208 21.7754 21.5224 21.6026C21.6229 21.5408 21.7234 21.4791 21.8239 21.4174C22.2134 21.1458 22.54 20.8002 22.8038 20.3558C22.942 20.1212 23.0551 19.899 23.1431 19.6768C21.5349 19.862 20.0147 19.8867 18.6956 19.7015L18.7081 19.6892Z",
    fill: "url(#paint19_linear_3820_34556)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M28.4835 18.6766C28.3328 18.9852 28.1694 19.2938 27.9935 19.6024C26.9256 21.3676 25.3301 22.8242 23.5209 23.8488C20.7946 25.4042 17.5406 25.9844 14.7641 25.1943C10.392 23.9476 8.74612 19.7505 10.8191 15.5781C10.1909 14.9979 9.6507 14.4178 9.18584 13.887C9.12303 13.9857 9.04765 14.0968 8.98483 14.2079C5.59266 19.7875 7.59027 25.6634 13.4575 27.3299C16.9753 28.3298 21.0961 27.5891 24.5511 25.6264C26.8502 24.3179 28.873 22.4786 30.2299 20.2443C30.6947 19.4666 31.0591 18.6889 31.3354 17.9235C30.4309 18.1951 29.476 18.4544 28.4961 18.6889L28.4835 18.6766Z",
    fill: "url(#paint20_linear_3820_34556)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3820_34556",
    x1: 0.666016,
    y1: 45.3333,
    x2: 47.1459,
    y2: 43.9519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3820_34556",
    x1: -4.95117,
    y1: -12.5926,
    x2: 50.6359,
    y2: -10.0304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169643,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864081,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.42
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3820_34556",
    x1: 29.6443,
    y1: 41.2777,
    x2: 20.1796,
    y2: 24.6756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFF8C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FEF5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FEEFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FDE598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FCD772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FBC643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FAB81E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B85E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#A84804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF9A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FCC227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E89C0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#EAA517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F1B934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F6C94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAD55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FCDB64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FDDE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3820_34556",
    x1: 39.2671,
    y1: 34.1016,
    x2: 12.7597,
    y2: 29.0767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBAD07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDC52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FED75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEF4A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FDF0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FCE692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FAD577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F7BE51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F3A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F19006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#CD5204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#AA5304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EBA707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EFB11B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F5C13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FACD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FED766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FDD664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FDD55D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FDCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDCB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FAC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F2B31C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E9A319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F4C64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCE076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDE482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD951"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3820_34556",
    x1: 30.3897,
    y1: 37.9172,
    x2: 20.7653,
    y2: 21.0349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DF8506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E18A08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E89A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F3B51B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F7BE1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F4AE20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F3A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FCC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC6905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3820_34556",
    x1: 47.4791,
    y1: 18.7446,
    x2: 24.9834,
    y2: 14.4802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D57F06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D07905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C36905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AE4E04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C05604"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3820_34556",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.632 44.3554) rotate(-169.749) scale(10.5013 4.35225)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1AE20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3820_34556",
    x1: 38.5443,
    y1: 21.7243,
    x2: 16.5656,
    y2: 34.8574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDB6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEEF83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FDEC7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDE66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FDCE2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDC20B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDDA55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDDC5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3820_34556",
    x1: 20.9754,
    y1: 27.5194,
    x2: 31.9732,
    y2: 29.6042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#AA4604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#AD4E04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B76504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#BD7105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BA6B04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B25B04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#BA6205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85F04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3820_34556",
    x1: 27.7003,
    y1: 22.7128,
    x2: 25.6693,
    y2: 33.9425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEF4A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FDF2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDEC92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FDE377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FDD652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDCB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDE482"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3820_34556",
    x1: 16.5126,
    y1: 11.167,
    x2: 25.1181,
    y2: 28.4982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DF8506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E18A08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E89A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F3B51B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F7BE1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F4AE20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F3A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FCC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC6905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3820_34556",
    x1: 8.98358,
    y1: 26.2115,
    x2: 31.4785,
    y2: 12.9934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBAD07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDC52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FED75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEF4A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FDF0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FCE692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FAD577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F7BE51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F3A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F19006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#CD5204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#AA5304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EBA707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EFB11B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F5C13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FACD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FED766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FDD664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FDD55D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FDCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDCB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FAC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F2B31C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E9A319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F4C64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCE076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDE482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD951"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3820_34556",
    x1: 17.0099,
    y1: 28.2294,
    x2: 21.8259,
    y2: 6.10203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFF8C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FEF5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FEEFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FDE598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FCD772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FBC643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FAB81E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B85E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#A84804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DF9A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FCC227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E89C0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#EAA517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F1B934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#F6C94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAD55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FCDB64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FDDE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3820_34556",
    x1: 17.1726,
    y1: 25.3315,
    x2: 20.9875,
    y2: 7.80345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D57F06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D07905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C36905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AE4E04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FCBB07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85F04"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_3820_34556",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.4998 17.1768) rotate(-77.2953) scale(8.94476 9.08842)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1AE20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_3820_34556",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.2895 18.4327) rotate(62.7818) scale(10.2459 10.3524)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FEFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FCF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F9F2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F5E8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F0DBC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#E9CBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E1B887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#D7A261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#CD8937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C16C05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3820_34556",
    x1: 8.34675,
    y1: 14.4838,
    x2: 30.0952,
    y2: 19.3869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDB6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEEF83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FDEC7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDE66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FDCE2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDC20B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDDA55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDDC5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3820_34556",
    x1: 14.4563,
    y1: 9.92254,
    x2: 23.6568,
    y2: 26.1413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CE7B05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#C97504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#BE6504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#AB4A04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#BA6205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85F04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3820_34556",
    x1: 14.2852,
    y1: 9.6351,
    x2: 23.4857,
    y2: 25.8539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEF4A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FDF2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDEC92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FDE377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FDD652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDCB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDE482"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3820_34556",
    x1: 16.6125,
    y1: 22.8531,
    x2: 17.7047,
    y2: 19.5507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3820_34556",
    x1: 16.673,
    y1: 27.0523,
    x2: 18.5353,
    y2: 19.5732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon);
export default __webpack_public_path__ + "static/media/money-icon.8e5f22760331cd67e5520e47542f0857.svg";
export { ForwardRef as ReactComponent };